var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 841.9 595.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90) translate(-125,-725)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 420.9,
    cy: 296.5,
    r: 250,
    stroke: "#E6E1E5",
    strokeWidth: 18,
    fill: "#36333b"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 189,
    x2: 310,
    y2: 145,
    stroke: "#559e5d",
    strokeWidth: 32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 145,
    r: 16,
    fill: "#559e5d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 210,
    r: 16,
    fill: "#36333b"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 550,
    y1: 407,
    x2: 310,
    y2: 450,
    stroke: "#559e5d",
    strokeWidth: 32
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 450,
    r: 16,
    fill: "#559e5d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 545,
    cy: 389,
    r: 16,
    fill: "#36333b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,148)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#E6E1E5",
    viewBox: "0 0 500 500",
    width: "300px",
    height: "300px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375 41.667C340.729 41.667 312.5 69.896 312.5 104.167C312.5 108.145 312.954 112.023 313.68 115.804L165.039 202.515C154.136 193.289 140.252 187.5 125 187.5C90.729 187.5 62.5 215.729 62.5 250C62.5 284.271 90.729 312.5 125 312.5C140.252 312.5 154.136 306.711 165.039 297.485L313.68 384.155C312.949 387.948 312.5 391.841 312.5 395.833C312.5 430.104 340.729 458.333 375 458.333C409.271 458.333 437.5 430.104 437.5 395.833C437.5 361.562 409.271 333.333 375 333.333C359.739 333.333 345.867 339.153 334.961 348.389L186.32 261.637C187.046 257.857 187.5 253.978 187.5 250C187.5 246.022 187.046 242.143 186.32 238.363L334.961 151.652C345.864 160.878 359.748 166.667 375 166.667C409.271 166.667 437.5 138.438 437.5 104.167C437.5 69.896 409.271 41.667 375 41.667zM375 83.333C386.753 83.333 395.833 92.414 395.833 104.167C395.833 115.919 386.753 125 375 125C363.247 125 354.167 115.919 354.167 104.167C354.167 92.414 363.247 83.333 375 83.333zM125 229.167C136.753 229.167 145.833 238.247 145.833 250C145.833 261.753 136.753 270.833 125 270.833C113.247 270.833 104.167 261.753 104.167 250C104.167 238.247 113.247 229.167 125 229.167zM375 375C386.753 375 395.833 384.081 395.833 395.833C395.833 407.586 386.753 416.667 375 416.667C363.247 416.667 354.167 407.586 354.167 395.833C354.167 384.081 363.247 375 375 375z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d706a5b62287910fb6ae12bfaff950f8.svg";
export { ForwardRef as ReactComponent };